import React, { useState } from "react";
import { showBasicAlert } from "../../../core/common/useAlert";
import api from "../../../services/api";
import { Provider } from "./emailSelect";
import styles from "./EmailSelect.module.css"; // Using the same module for styles

interface EmailLoginFormProps {
  provider: Provider;
  // onLoginSuccess: () => void;
  onLoginSuccess: (email: string) => void;
}

const EmailLoginForm: React.FC<EmailLoginFormProps> = ({
  provider,
  onLoginSuccess,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const signature = localStorage.getItem("signature");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    if (!signature) {
      showBasicAlert(
        "Authentication signature is missing. Please log in again."
      );
      setIsLoading(false);
      return;
    }

    try {
      const response = await api.post("mailService/loginIMAPController", {
        signature,
        email,
        password,
        provider,
      });
      const loginMessage = response.data?.message?.message || "";
      if (loginMessage.toLowerCase().includes("login successful")) {
        setEmail("");
        setPassword("");
        await new Promise((resolve) => setTimeout(resolve, 50));
        onLoginSuccess(email);
      }
    } catch (error:any) {
      showBasicAlert(error.data.message[0].msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <h3 className={styles.loginTitle}>Login to {provider}</h3>
        <form onSubmit={handleLogin}>
          {/* Email Field */}
          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.formLabel}>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.formInput}
              placeholder="you@example.com"
              required
            />
          </div>

          {/* Password Field */}
          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.formLabel}>
              Password
            </label>
            <div className={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={styles.formInput}
                placeholder="Enter your password"
                required
              />
              <span
                className={styles.passwordToggle}
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? "Hide Password" : "Show Password"}
              >
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>
          </div>

          {/* Submit Button */}
          <div className={styles.buttonGroup}>
            <button
              type="submit"
              className={styles.loginButton}
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailLoginForm;
